import { Nullable } from "models/Nullable";

export function searchStringFrom(str: string): string
export function searchStringFrom(str: Nullable<string>): Nullable<string>
export function searchStringFrom(str: Nullable<string>) {
    if (str === null) {
        return null
    }
    return str.toLowerCase().replaceAll(' ', '')
}